<template>
  <div>
    <h1>Add Survey</h1>
    <vue-form-generator :schema="buildSchema('survey', 'surveySchema', 'basicInfo', 'new')" :model="formModel" :options="formOptions" class="vue-form-generator--admin"></vue-form-generator>
  </div>
</template>

<script>
  import router from '@/router';
  import newForm from '@/mixins/new-form';

  export default {
    name: 'admin-new-survey',
    mixins: [newForm],

    data() {
      return {
        formName: 'Survey',
        formIndex: 'admin-surveys',
        formModel: {
          branding: 'rradar'
        }
      };
    },

    methods: {
      addSurvey(data, form) {
        this.$store.dispatch('admin/addSurvey', { data, form }).then(() => {
          router.push({ name: 'admin-surveys' });
        });
      },
    },
  };
</script>
